import {Component, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FieldConfig} from '../field.interface';

@Component({
    selector: 'app-radiobutton',
    template: `



@for (item of field.options; track item) {
  <fieldset>
    <label for="{{item.name}}_name">{{item.name}}</label>
    <input id="{{item.name}}_name" type="radio" formControlName="{{field.key}}" value="{{item.value}}">
  </fieldset>
}
`,
    standalone: false
})
export class RadiobuttonComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  // @HostBinding('class') rowClass = 'col-md-6';
  constructor() { }
  ngOnInit() {

    //  this.rowClass = this.field.rowClass === 'large' ? 'col-md-12' : 'col-md-6';
  }


}
